import { dateFormatter } from 'zens-storybook'

import { capitalizeWords } from '../helper'
import { Model } from '../general'
import { I18nStore } from '../i18n'
import { RoleType } from '../data'

interface RootStore {
  i18n: I18nStore
}

export enum Status {
  Invited = 0,
  Active = 1,
  Unknown,
}

interface CompanyRole {
  owner_company_id: number
  role_id: RoleType
}

export interface Data {
  id: number
  name?: string
  email?: string
  password?: string
  language?: string
  status?: number
  created_at?: string
  owner_company_id?: number
  role_id?: RoleType
  companies?: CompanyRole[]
}

export interface DataEmail {
  id: number
  email?: string
  password?: string
}

export interface DataPassword {
  id: number
  email?: string
  password?: string
  new_password?: string
}

class Profile extends Model<Data, RootStore> {
  get email() {
    return this.data.email
  }

  get displayName() {
    return capitalizeWords(this.data.name)
  }

  get displayCreatedAt() {
    const { i18n } = this.store
    return this.data.created_at ? dateFormatter(this.data.created_at, 'PPP', i18n.language) : ''
  }
  get status() {
    switch (this.data.status) {
      case 0:
        return Status.Invited
      case 1:
        return Status.Active
      default:
        return Status.Unknown
    }
  }

  get language() {
    return this.data.language
  }

  get companyId() {
    return this.data.owner_company_id
  }

  get isSystemAdministrator() {
    return this.data.role_id === RoleType.SystemAdministrator
  }

  roleForCompany(companyId: number): RoleType | undefined {
    if (this.data.role_id !== RoleType.SystemAdministrator) {
      return this.data.companies?.find((company) => company.owner_company_id === companyId)?.role_id  
    } 

    return RoleType.SystemAdministrator
  }
}

export default Profile
